// "use client";

// import { ThemeProvider } from "@mui/material";
// import { theme } from "./theme/theme";
// import { Provider } from "react-redux";
// import { store } from "./store";
// import { CheckAuthUser } from "./getUser";

// export function Providers({ children }: { children: React.ReactNode }) {
//   return (
//     <Provider store={store}>
//       <ThemeProvider theme={theme}>
//         <CheckAuthUser>{children}</CheckAuthUser>
//       </ThemeProvider>
//     </Provider>
//   );
// }


"use client";

import { ThemeProvider } from "@mui/material";
import { theme } from "./theme/theme";
import { Provider } from "react-redux";
import { store } from "./store";
import { LogRocketProvider } from "./components/LogRocketProvider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        {/* LogRocket needs the Redux store, so it sits inside <Provider> */}
        <LogRocketProvider>{children}</LogRocketProvider>
      </ThemeProvider>
    </Provider>
  );
}